import { graphql } from "@opensea/graphql"
import { TokenPriceFragment } from "@/components/price/TokenPrice.fragment"

export const OfferAggregateTotalsFragment = graphql(
  `
    fragment OfferAggregateTotals on OfferAggregateTotal {
      totalOffers
      totalValue {
        ...TokenPrice
        token {
          unit
        }
      }
    }
  `,
  [TokenPriceFragment],
)
